module.exports = __webpack_public_path__ + "sgby/img/wei.a52b076.png";